// removed by extract-text-webpack-plugin
module.exports = {"localTime":"localTime---1PdQ8"};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/components/conversation/ContactSideBar/Person/Profile/LocalTime/style.styl
// module id = k30Z
// module chunks = 89